import * as React from "react";
import { Loader, Container, Header, Table } from "semantic-ui-react";
import { connect } from "react-redux";
import { isRequestActive } from "redux-request-loading";
import { Button } from "semantic-ui-react";

import { MyResultTableEntryModel } from "@teamprevent/common/stressRiskAssessment/models";

import { loadSraTasks } from "../actions";
import { ApplicationState } from "../../applicationState";
import { LOAD_SRA_TASKS } from "../actionTypes";

import { ResendCompletionRequestButton } from "./ResendCompletionRequestButton";

interface StateProps {
    sraTasks: MyResultTableEntryModel[];
    loading: boolean;
}

interface DispatchProps {
    loadSraTasks: () => void;
}

type Props = StateProps & DispatchProps;

export const MyResultsUnconnected: React.FunctionComponent<Props> = (props: Props) => {
    React.useEffect(() => {
        props.loadSraTasks();
    }, []);

    if (props.loading) {
        return <Loader active>Loading</Loader>;
    }

    return (
        <Container>
            <Header as="h1" className="accent-header">Results</Header>
            <Table striped>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Full Name</Table.HeaderCell>
                        <Table.HeaderCell>ID</Table.HeaderCell>
                        <Table.HeaderCell>Overall Score</Table.HeaderCell>
                        <Table.HeaderCell>Completed</Table.HeaderCell>
                        <Table.HeaderCell />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.sraTasks.map(c => (
                        <Table.Row key={c.sraManagerSectionId}>
                            <Table.Cell>
                                {c.fullName}
                            </Table.Cell>
                            <Table.Cell width="2">
                                {c.caseNumber}
                            </Table.Cell>
                            <Table.Cell width="2">
                                {c.overallScore.toFixed(2)}
                            </Table.Cell>
                            <Table.Cell width="2">
                                {c.completed === true ? "Yes" : "No"}
                            </Table.Cell>
                            <Table.Cell textAlign="right" width="3">
                                {!c.completed && <ResendCompletionRequestButton sraManagerSectionId={c.sraManagerSectionId} />}
                                {c.completed &&
                                    <a
                                        href={`/assessmentandwellbeing/myresults/${c.sraEmployeeSectionId}`}
                                    >
                                        <Button content="View" type="button" />
                                    </a>
                                }
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </Container>
    );
};

const mapStateToProps = (state: ApplicationState): StateProps => ({
    sraTasks: state.sraTasks,
    loading: isRequestActive(state, LOAD_SRA_TASKS)
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    loadSraTasks: () => dispatch(loadSraTasks())
});

export const MyResults = connect(mapStateToProps, mapDispatchToProps)(MyResultsUnconnected);
